// Coralvolt Theme JS
document.addEventListener('DOMContentLoaded', () => {

  /* ---------- Mobile navigation ---------- */
  const toggle = document.querySelector('.mobile-menu-toggle');
  const nav = document.querySelector('.site-header__nav');

  if (toggle && nav) {
    const setOpen = (open) => {
      nav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.querySelector('.material-symbols-outlined').textContent = open ? 'close' : 'menu';
    };

    toggle.addEventListener('click', () => {
      setOpen(!nav.classList.contains('is-open'));
    });

    // Close on Escape, returning focus to the button that opened it.
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        setOpen(false);
        toggle.focus();
      }
    });

    // Close when tapping outside the header.
    document.addEventListener('click', (e) => {
      if (!nav.classList.contains('is-open')) return;
      if (e.target.closest('.site-header')) return;
      setOpen(false);
    });

    // The drawer is a mobile affordance; drop it if the viewport grows past
    // the breakpoint so the desktop nav is never left in an "open" state.
    window.matchMedia('(min-width: 990px)').addEventListener('change', (e) => {
      if (e.matches) setOpen(false);
    });
  }

  /* ---------- Resources dropdown: hover on desktop, click/keyboard everywhere ---------- */
  document.querySelectorAll('[data-nav-dropdown]').forEach((dd) => {
    const btn = dd.querySelector('.nav-dropdown__toggle');
    const set = (open) => { dd.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', String(open)); };
    btn.addEventListener('click', () => set(!dd.classList.contains('is-open')));
    dd.addEventListener('keydown', (e) => { if (e.key === 'Escape') { set(false); btn.focus(); } });
    dd.addEventListener('focusout', (e) => { if (!dd.contains(e.relatedTarget)) set(false); });
    document.addEventListener('click', (e) => { if (!dd.contains(e.target)) set(false); });
  });

  /* ---------- Header search: icon that expands into a field ---------- */
  const hs = document.querySelector('[data-header-search]');
  if (hs) {
    const toggle = hs.querySelector('.header-search__toggle');
    const input = hs.querySelector('input[type="search"]');
    const setOpen = (open) => { hs.classList.toggle('is-open', open); toggle.setAttribute('aria-expanded', String(open)); if (open) input.focus(); };
    toggle.addEventListener('click', () => setOpen(!hs.classList.contains('is-open')));
    input.addEventListener('keydown', (e) => { if (e.key === 'Escape') { setOpen(false); toggle.focus(); } });
    document.addEventListener('click', (e) => { if (hs.classList.contains('is-open') && !hs.contains(e.target) && !input.value) setOpen(false); });
  }

  /* ---------- Part Finder ----------
     The select used to navigate on change, which made the button unreachable.
     The button is now the action, so a mis-tap on the dropdown costs nothing. */
  const partFinderSelect = document.getElementById('part-finder-select');
  if (partFinderSelect) {
    const go = () => { if (partFinderSelect.value) window.location.href = partFinderSelect.value; };
    partFinderSelect.addEventListener('change', go);
    const form = partFinderSelect.closest('form');
    if (form) form.addEventListener('submit', (e) => { e.preventDefault(); go(); });
  }

  /* ---------- Collection jump menu ---------- */
  document.querySelectorAll('[data-collection-jump]').forEach((select) => {
    select.addEventListener('change', () => {
      if (select.value) window.location.href = select.value;
    });
  });

  /* ---------- Collection sort ---------- */
  const sortBy = document.getElementById('SortBy');
  if (sortBy) {
    sortBy.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortBy.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Product gallery ---------- */
  const mainImage = document.getElementById('ProductMainImage');
  const thumbs = document.querySelectorAll('.product-gallery__thumb');

  if (mainImage && thumbs.length) {
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        mainImage.src = thumb.dataset.full;
        mainImage.alt = thumb.dataset.alt || mainImage.alt;
        thumbs.forEach((t) => {
          t.classList.remove('is-active');
          t.removeAttribute('aria-current');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------- Variant selection ---------- */
  const variantSelect = document.getElementById('VariantSelect');
  const priceEl = document.getElementById('ProductPrice');
  const submit = document.getElementById('ProductSubmit');

  if (variantSelect && priceEl) {
    variantSelect.addEventListener('change', () => {
      const opt = variantSelect.selectedOptions[0];
      if (!opt) return;

      const current = priceEl.querySelector('.product-details__price-current');
      if (current) current.textContent = opt.dataset.price;

      let was = priceEl.querySelector('.product-details__price-was');
      if (opt.dataset.compare) {
        if (!was) {
          was = document.createElement('span');
          was.className = 'product-details__price-was';
          priceEl.appendChild(was);
        }
        was.textContent = opt.dataset.compare;
      } else if (was) {
        was.remove();
      }

      if (submit) {
        const available = opt.dataset.available === 'true';
        submit.disabled = !available;
        submit.textContent = available ? 'Add to Cart' : 'Sold Out';
      }

      // Keep ?variant= in sync so a refresh or a shared link opens the same
      // pack size the shopper is looking at.
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantSelect.value);
      window.history.replaceState({}, '', url);
    });
  }
});
